
import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import './aside.css'
import profile from '../assets/profile.jpg'
function HrDashboardAside() {
    const [empId, setEmpId] = useState('');
    const [empName, setEmpName] = useState('');
    const [designation, setDesignation] = useState('');
    const [isSidebarOpen, setIsSidebarOpen] = useState(
        () => localStorage.getItem('mobileSidebarOpen') === 'true'
    );
    const navigate = useNavigate(); // For navigation after logout



    // Effect to load employee details from localStorage
    useEffect(() => {
        const storedEmpId = localStorage.getItem('empId');
        const storedEmpName = localStorage.getItem('empName');
        const storedDesignation = localStorage.getItem('designation');

        // If employee details are missing, show alert and navigate to homepage
        if (!storedEmpId || !storedEmpName || !storedDesignation) {
            alert('Session expired. Please log in again.');
            navigate('/'); // Navigate to homepage (not necessarily the login page)
        } else {
            setEmpId(storedEmpId);
            setEmpName(storedEmpName);
            setDesignation(storedDesignation);
        }
    }, [navigate]);



    const handleLogout = () => {
        localStorage.removeItem('empId');
        localStorage.removeItem('empName');
        localStorage.removeItem('designation');
        navigate('/'); // Redirect to homepage after logout
    };
    const handleSidebarToggle = () => {
        setIsSidebarOpen((prev) => {
            const next = !prev;
            localStorage.setItem('mobileSidebarOpen', String(next));
            return next;
        });
    };

    return (
        <div className={`sideBar ${isSidebarOpen ? 'is-open' : ''}`}>
            <button
                type="button"
                className="mobile-sidebar-toggle"
                aria-label="Toggle sidebar"
                aria-expanded={isSidebarOpen}
                onClick={handleSidebarToggle}
            >
                <span></span>
                <span></span>
                <span></span>
            </button>
            <div className="imageBlock">
                <img src={profile} alt="" />

            </div>
            <div className="employeeDetails">
                <h4>Employee ID:<span>{empId} </span></h4>
                <h4>Employee Name:<span className="empvalues">{empName}</span></h4>
                <h4>Designation:<span className="empvalues">{designation}</span></h4>
            </div>


            <Link to="/Leavemanagement" className="links">Leave Management</Link>
            <Link to="/Policies" className="links">Policies</Link>
            <Link to="/Announcements" className="links">Announcements</Link>
            <Link to="/Employeeprofile" className="links">Employee Profile</Link>
            <div className="logout-container">
                <button onClick={handleLogout} className="logout-button">
                    Logout
                </button>

            </div>
        </div>
    )


}

export default HrDashboardAside;